/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.27"
        height="84.07"
        viewBox="0 0 82.27 84.07"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M66.94 13.6a8.37 8.37 0 0 1 8.35 8.1v5.54a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09v-5.41a5.87 5.87 0 0 0-5.63-5.85h-3.26a1.25 1.25 0 0 1-1.21-1.29 1.23 1.23 0 0 1 1.09-1.2h3.15ZM28.48 13.6a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22h-11.6a1.25 1.25 0 0 1-.13-2.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M61.52 6.96a1.25 1.25 0 0 1 1.55.71v.12l5.22 17.52a1.24 1.24 0 0 1-.85 1.55 1.26 1.26 0 0 1-1.5-.71v-.12l-4.87-16.3L8.7 26.86a1.25 1.25 0 0 1-1.53-.68v-.12a1.25 1.25 0 0 1 .63-1.56h.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M53.23.15a1.22 1.22 0 0 1 1.64.43l.06.11 4.08 8.1a1.25 1.25 0 0 1-2.17 1.24l-.07-.12-3.48-6.95L8.92 26.77a1.25 1.25 0 0 1-1.62-.39l-.07-.12a1.24 1.24 0 0 1 .39-1.62l.12-.07Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M17.01 13.6a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H6.77a4.161 4.161 0 0 0-.2 8.32h63a8.37 8.37 0 0 1 8.35 8.1v12.53a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-12.4a5.86 5.86 0 0 0-5.63-5.84h-63a6.661 6.661 0 0 1-.23-13.32h10.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M2.61 20.55v55.24a5.89 5.89 0 0 0 5.63 5.84h61.37a5.88 5.88 0 0 0 5.85-5.64v-12h2.5v11.74a8.37 8.37 0 0 1-8.1 8.34H8.46a8.39 8.39 0 0 1-8.35-8.1V20.55Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M81.01 43.85H60.29c-5.18 0-9.8 4.93-9.8 10.65a10.65 10.65 0 0 0 10.63 10.65H81a1.25 1.25 0 0 0 1.25-1.25V45.1a1.25 1.25 0 0 0-1.24-1.25Zm-1.25 2.5v16.3H61.14A8.16 8.16 0 0 1 53 54.5v-.25c.13-4.27 3.61-7.9 7.3-7.9Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M64.29 54.5a3.1 3.1 0 1 1-3.11-3.09 3.08 3.08 0 0 1 3.11 3.04"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'WalletIcon';

export default Icon;
